<template>
  <md-toolbar class="md-primary">
    <md-button class="md-icon-button" to="/">
      <md-icon :md-src="require('../assets/calc.svg')" />
    </md-button>
    <h3 class="md-title" style="flex: 1">{{$t('KiraFanCalc')}}</h3>
    <md-menu md-direction="bottom-start">
      <md-button md-menu-trigger class="md-icon-button">
        <md-icon :md-src="require('../assets/translate.svg')" />
      </md-button>

      <md-menu-content>
        <md-menu-item @click="setLocale('ja')">日本語</md-menu-item>
        <md-menu-item @click="setLocale('zh')">中文</md-menu-item>
        <md-menu-item @click="setLocale('en')">English</md-menu-item>
      </md-menu-content>
    </md-menu>
  </md-toolbar>
</template>

<script>
export default {
  name: "ToolBar",
  methods: {
    setLocale(lang) {
      this.$i18n.locale = lang;
    }
  }
};
</script>

<style lang="scss">
@import "~vue-material/src/components/MdLayout/mixins";

.toolbar-phone {
  z-index: 9 !important;
  display: none !important;
  @include md-layout-xsmall {
    display: flex !important;
  }
}

.toolbar-desktop {
  z-index: 9 !important;
  @include md-layout-xsmall {
    display: none !important;
  }
  position: fixed !important;
  top: 0;
}
</style>